export default __webpack_public_path__ + "static/media/left-arrow.2a6400fc.svg";